import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IReferral, IReferralListSummary } from "../models/IReferral";
import { IPage } from "../models/IPage";
export class ReferralApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }
    getReferral(id: number, refresh: boolean, success: (data: IReferral) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IReferral>(`${Utils.LIB_API_BASE_URL}/referral/${id}?refresh=${refresh}`, success, error, final);
    }
    deleteFile(fileId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/referral/file/${fileId}`, success, error, final);
    }
    getReferralsUnderReviewSummary(pageSelect: IPage, success: (data: IPaginatedResponse<IReferralListSummary[]>) => void, error?: (message: string) => void, final?: () => void) {
        this.getPaginated<IReferralListSummary[]>(`${Utils.LIB_API_BASE_URL}/referral/underReviewSummary?pageNumber=${pageSelect.pageNumber}&pageSize=${pageSelect.pageSize}`, success, error, final);
    }
    downloadReferralAttachment(referralAttachmentId: number, fileName?: string, error?: (message: string) => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/referral/file/${referralAttachmentId}`, fileName ?? "", undefined, error);
    }
}